
const bannerList = [
    {
        'id': 1,
        'image': "https://http2.mlstatic.com/D_NQ_889741-MLA48254043326_112021-F.webp",
        'title': "Especial Deportes",
        'url': "/login"
    },
    {
        'id': 2,
        'image': "https://http2.mlstatic.com/D_NQ_763758-MLA48193979880_112021-F.webp",
        'title': "Semana saludable",
        'url': "/login"
    },
]


export default bannerList